"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBox = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("../theme");
var structure_1 = require("../structure");
exports.CheckBox = react_1.default.memo(function (props) {
    return (react_1.default.createElement(Area, { className: props.className },
        react_1.default.createElement(Label, null,
            react_1.default.createElement(Svg, null, props.checked ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("rect", { width: "16", height: "16", rx: "4", fill: theme_1.theme.colors.red1 }),
                react_1.default.createElement("path", { d: "M6.50001 9.85761L4.52123 7.87883L4.40001 7.75761L4.27879 7.87883L3.57879 8.57883L3.45758 8.70005L3.57879 8.82127L6.37879 11.6213L6.50001 11.7425L6.62123 11.6213L12.6212 5.62127L12.7424 5.50005L12.6212 5.37883L11.9212 4.67883L11.8 4.55761L11.6788 4.67883L6.50001 9.85761Z", fill: theme_1.theme.colors.white, stroke: theme_1.theme.colors.white, strokeWidth: "0.342857" }))) : (react_1.default.createElement("rect", { x: "1", y: "1", width: "14", height: "14", rx: "3", stroke: props.disabled ? theme_1.theme.colors.gray2Transparent : theme_1.theme.colors.gray3, strokeWidth: "2" }))),
            react_1.default.createElement(Input, __assign({}, props, { type: "checkbox", ref: props.inputRef }))),
        props.label,
        !props.tooltip ? null : react_1.default.createElement(structure_1.Tooltip, { tooltip: props.tooltip })));
});
var Area = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n"], ["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n"])));
var Label = styled_components_1.default.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n"], ["\n  position: relative;\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n"])));
var Input = styled_components_1.default.input.attrs(function () { return ({
    type: "checkbox",
}); })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  margin: 0;\n  &:hover {\n    cursor: ", ";\n  }\n"], ["\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  margin: 0;\n  &:hover {\n    cursor: ", ";\n  }\n"])), function (props) { return (props.disabled ? undefined : "pointer"); });
var Svg = styled_components_1.default.svg.attrs(function () { return ({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
}); })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
